import { render } from "./NotFound.vue?vue&type=template&id=f86e687e"
const script = {}
script.render = render

export default script